/** Symbol aus dem Sprite des Designsystems (oberflaeche.md §1.4): immer `aria-hidden`, Name = Datei ohne Endung. */
export function Symbol({ name, className }: { name: string; className?: string }) {
  return (
    <svg className={className ? `ic ${className}` : "ic"} aria-hidden="true" focusable="false">
      <use href={`#i-${name}`} />
    </svg>
  );
}
